import React from "react";
import "../../../src/global.scss";
import Head from "./Head";
import { useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();

  const renderActive = (navItem) => {
    const path = location?.pathname?.split("/")[1];
    if (path === navItem) {
      return "renderMenu";
    }
    return "";
  };
  return (
    <>
      <Head />
      <div className="Nav">
        <ul>
          <li className={renderActive("")}>
            <a href="./">Home </a>
          </li>
          <li className={renderActive("aboutus")}>
            <a href="./aboutus">About Us</a>
          </li>
          <li className={renderActive("harddrinks")}>
            <a href="./harddrinks">Hard Drinks</a>
          </li>
          <li className={renderActive("softdrinks")}>
            <a href="./softdrinks">Soft Drinks</a>
          </li>
          <li className={renderActive("snacks")}>
            <a href="./snacks">Snacks</a>
          </li>
        </ul>
        <div class="Searchbar">
          <div class="search">
            <input
              type="text"
              class="searchTerm"
              placeholder="What are you looking for?"
            ></input>
            <button type="submit" class="searchButton">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
